import React, { Component } from "react";
// import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {
  ChevronRightIcon,
  ChevronLeftIcon
} from '../bundles/IconsBundle';
import { setTitle } from "../actions/AppActions";
import FirmaDialog from "./dialogs/FirmaDialog";
import DbTasks from '../db/DbTasks';
import { SaveDataBock } from "../actions/TaskActions";
import { fetchCoordinates } from '../helpers/utils';
import { Text } from '../extensions/LangaugeContainer';

const styles = {
  div: {
    display: "block",
    float: "left",
    textAlign: "left",
    paddingLeft: "10px",
    zIndex: 999
  },
  par: {
    height: 43,
    marginTop: 0
  },
  appbar: {
    top: 0,
    zIndex: 1000
  },
  cont: {
    overflowY: "scroll",
    height: "calc(100vh - 57px)",
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 10,
    backgroundColor: "#DDDDDD"
  },
  table: {
    boxShadow: "1px 1px 1px 1px #AAA",
    borderRadius: "0px",
    textAlign: "left",
    color: "#444",
    margin: "5px"
  },

}

class BockListe extends Component {

  state = {
    firmaDialogOpen: false,
    date: new Date(),
    dialogBock: {},
  }

  componentDidMount() {
    this.props.setTitle(<Text tid="bockList"/>);
  }

  returnLkwListEmpty = (data) => {
    if (data.length === 0) return <TableRow><TableCell colSpan={2} style={{ backgroundColor: "white", textAlign: "center" }}><Text tid="emptyList"/></TableCell></TableRow>;
    return null;
  }

  returnKundeListEmpty = (data) => {
    if (data.length === 0) return <TableRow><TableCell colSpan={2} style={{ backgroundColor: "white", textAlign: "center" }}><Text tid="emptyList"/></TableCell></TableRow>;
    return null;
  }

  leaveBockConfirmation = (bock) => {
    this.setState({ ...this.state, firmaDialogOpen: true, dialogBock: bock })
  }

  leaveBockToLocation = async (uniqueId) => {
    let db = new DbTasks();
    let getAuftrag = await new DbTasks().getSpecificAppointment(uniqueId);

    let bockObj = Object.assign({},this.state.dialogBock);

    bockObj.AuftragNr = getAuftrag.AuftragNr;
    bockObj.DateLeft = new Date();
    bockObj.Status = 1; //Ostavljen kod kupca
    bockObj.ekName = getAuftrag.EkName;
    bockObj.ekOrt = getAuftrag.EkOrt;
    bockObj.ekPLZ = getAuftrag.ekPLZ;
    bockObj.Strasse = getAuftrag.EkStrasse;
    bockObj.FirmaID = getAuftrag.IdFirma;
    bockObj.Kunden_Nr = getAuftrag.Kunden_Nr;
    bockObj.ToUpload = 1;

    let bockPos = await fetchCoordinates();

    if(!bockPos){
      bockObj.Latitude = getAuftrag.Lat;
      bockObj.Longitude = getAuftrag.Lng;
    }else{      
      bockObj.Latitude = bockPos.latitude;
      if(!bockPos.Latitude) bockObj.Latitude = getAuftrag.Lat;
      bockObj.Longitude = bockPos.longitude;
      if(!bockPos.Longitude) bockObj.Longitude = getAuftrag.Lng;
    }

    this.props.SaveDataBock(bockObj); //Snimi promjene za bock
    await db.uploadBockData(this.props.settings);
    

    this.setState({
      ...this.state,
      firmaDialogOpen: false,
      dialogBock: {},
    })

  }

  returnBockToLkw = (bock) => {
    bock.DatePickUp = new Date();
    bock.Status = 2;
    bock.ToUpload = 1;

    this.props.SaveDataBock(bock); //Snimi promjene za bock
  }

  handleCloseDialogs = () => {
    this.setState({
      ...this.state,
      firmaDialogOpen: false,
    });
  };

  render() {
    let bocks = this.props.bocks || [];
    let aufLkw = bocks.filter(function (f) {
      return f.Status === 2;
    });
    let beimKunde = bocks.filter(function (f) {
      return f.Status === 1; //inicijalno !== 1(kod sa stare app), postoje bokovi sa statusom 0, i oni se sa uslovom !== 1 prikažu u listi kao da su ostavljeni kod kupca.
    });

    return (
      <div style={styles.cont}>
        <Grid container spacing={8} direction="row" justify="flex-start" alignItems="flex-start">
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <Table style={styles.table}>
              <TableHead>
                <TableRow style={{ height: 40 }}>
                  <TableCell style={{ textAlign: "center", color: "white", backgroundColor: "#00B0DE", fontSize: 16 }}><Text tid="onTheTruck"/></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.returnLkwListEmpty(aufLkw)}
                {aufLkw.map(val => (
                  <TableRow key={val.id}>
                    <TableCell style={{ backgroundColor: "white", paddingLeft: "5px" }}>
                      <Grid container spacing={0} direction="row" justify="space-between" alignItems="flex-start" style={{ marginLeft: "0px" }}>
                        <Grid item xs={8} sm={8} md={8} lg={8}>
                          <div style={{ paddingTop: "5px", marginLeft: "5px" }}>
                            <Typography component="p">{val.Bock_Nr}</Typography>
                          </div>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={3} style={{ textAlign: "right", marginRight: "5px" }}>
                          <Button
                            size="small"
                            style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA", minWidth: "40px" }}
                            onClick={() => this.leaveBockConfirmation(val)}
                          >
                            <ChevronRightIcon style={{ color: "#00B0DE" }} />
                          </Button>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <Table style={styles.table}>
              <TableHead>
                <TableRow style={{ height: 40 }}>
                  <TableCell style={{ textAlign: "center", color: "white", backgroundColor: "#00B0DE", fontSize: 16 }}><Text tid="atTheCustomer"/></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.returnKundeListEmpty(beimKunde)}
                {beimKunde.map(val => (
                  <TableRow key={val.id}>
                    <TableCell style={{ backgroundColor: "white", paddingLeft: "5px" }}>
                      <Grid container spacing={0} direction="row" justify="space-between" alignItems="flex-start" style={{ marginLeft: "0px" }}>
                        <Grid item xs={8} sm={8} md={8} lg={8}>
                          <div style={{ paddingTop: "5px", marginLeft: "5px" }}>
                            <Typography component="p">{val.Bock_Nr}</Typography>
                          </div>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={3} style={{ textAlign: "right", marginRight: "5px" }}>
                          <Button
                            size="small"
                            style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA", minWidth: "40px" }}
                            onClick={() => this.returnBockToLkw(val)}
                          >
                            <ChevronLeftIcon style={{ color: "#00B0DE" }} />
                          </Button>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Grid>

        <FirmaDialog
          open={this.state.firmaDialogOpen}
          handleClose={this.handleCloseDialogs}
          leaveBockToLocation={this.leaveBockToLocation}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  bocks: state.tasks.bocks,
  settings: state.settings
});
// const mapStateToProps = createStructuredSelector({
//   appointments: getDayAppointmentsSelector()
// });

export default withRouter(
  connect(
    mapStateToProps, { setTitle, SaveDataBock }
  )(BockListe)
);

